class ChatModel {
  constructor(id,fromm,to,text,date,status) {
    this.id = id;
    this.fromm = fromm;
    this.to = to ;
    this.text = text;
    this.date = date;
    this.status = status || 'sent';
  }
}
export default ChatModel;
